import axios from "axios";
import Config from "../../../config/index";
import {
  GET_MANUFACTURER_REQUEST,
  GET_MANUFACTURER_SUCCESS,
  GET_MANUFACTURER_FAILURE,
  DELETE_MANUFACTURER_REQUEST,
  DELETE_MANUFACTURER_SUCCESS,
  DELETE_MANUFACTURER_FAILURE,
  CREATE_MANUFACTURER_REQUEST,
  CREATE_MANUFACTURER_SUCCESS,
  CREATE_MANUFACTURER_FAILURE,
  EDIT_MANUFACTURER_REQUEST,
  EDIT_MANUFACTURER_SUCCESS,
  EDIT_MANUFACTURER_FAILURE,
  UPLOADCSV_MANUFACTURER_REQUEST,
  UPLOADCSV_MANUFACTURER_SUCCESS,
  UPLOADCSV_MANUFACTURER_FAILURE,
} from "./manufacturerTypes";

let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

// --- GET API ---
const getManufacturerRequest = () => ({ type: GET_MANUFACTURER_REQUEST });
const getManufacturerSuccess = (payload) => ({
  type: GET_MANUFACTURER_SUCCESS,
  payload,
});
const getManufacturerFailure = (error) => ({
  type: GET_MANUFACTURER_FAILURE,
  payload: error,
});

const getManufacturer = (manufacturerId, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getManufacturerRequest());

    let url = manufacturerId
      ? `${baseUrl}/dpp/manufacturer/get_one?manufacturerId=${manufacturerId}`
      : `${baseUrl}/dpp/manufacturer/get_all`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getManufacturerSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getManufacturerFailure(err.message));
      });
  };
};

// --- DELETE API ---
const deleteManufacturerRequest = () => ({ type: DELETE_MANUFACTURER_REQUEST });
const deleteManufacturerSuccess = (payload) => ({
  type: DELETE_MANUFACTURER_SUCCESS,
  payload,
});
const deleteManufacturerFailure = (error) => ({
  type: DELETE_MANUFACTURER_FAILURE,
  payload: error,
});

const deleteManufacturer = (manufacturerId, cd, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(deleteManufacturerRequest());
    let url = `${baseUrl}/dpp/manufacturer/delete?manufacturerId=${manufacturerId}&cd=${cd}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteManufacturerSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteManufacturerFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- CREATE API ---
const createManufacturerRequest = () => ({ type: CREATE_MANUFACTURER_REQUEST });
const createManufacturerSuccess = (payload) => ({
  type: CREATE_MANUFACTURER_SUCCESS,
  payload,
});
const createManufacturerFailure = (error) => ({
  type: CREATE_MANUFACTURER_FAILURE,
  payload: error,
});

const createManufacturer = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(createManufacturerRequest());
    let url = `${baseUrl}/dpp/manufacturer/create`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createManufacturerSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createManufacturerFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- EDIT API ---
const editManufacturerRequest = () => ({ type: EDIT_MANUFACTURER_REQUEST });
const editManufacturerSuccess = (payload) => ({
  type: EDIT_MANUFACTURER_SUCCESS,
  payload,
});
const editManufacturerFailure = (error) => ({
  type: EDIT_MANUFACTURER_FAILURE,
  payload: error,
});

const editManufacturer = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(editManufacturerRequest());
    let url = `${baseUrl}/dpp/manufacturer/update`;

    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editManufacturerSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editManufacturerFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadCsvForManufacturerRequest = () => ({
  type: UPLOADCSV_MANUFACTURER_REQUEST,
});

const uploadCsvForManufacturerSuccess = (data) => ({
  type: UPLOADCSV_MANUFACTURER_SUCCESS,
  payload: data,
});

const uploadCsvForManufacturerFailure = (error) => ({
  type: UPLOADCSV_MANUFACTURER_FAILURE,
  payload: error,
});


const uploadCsvForManufacturer = (payload, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };

  return (dispatch) => {
    dispatch(uploadCsvForManufacturerRequest());

    let url = `${baseUrlFileUploadTemp}/dpp_manufacturer/upload`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForManufacturerSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForManufacturerFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


export {
  getManufacturer,
  editManufacturer,
  createManufacturer,
  deleteManufacturer,
  uploadCsvForManufacturer,
};
